<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "PurgeGlyphModal",
  components: {
    ModalWrapperChoice
  },
  props: {
    harsh: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    threshold() {
      return this.harsh ? 1 : 5;
    },
    extraMessage() {
      if (this.glyphsDeleted === 0) return `Это не Очистит никакие Глифы.`;
      if (this.glyphsDeleted === this.glyphsTotal) return `Это Очистит все ваши Глифы.`;
      return `${this.harsh ? `Жёсткая Чистка` : `Чистка`} удалит
        ${formatInt(this.glyphsDeleted)}/${formatInt(this.glyphsTotal)}
      ваших Глифов.`;
    },
    explanation() {
      if (this.harsh) return `Жёсткая Чистка удаляет Глифы, которые однозначно хуже любого другого Глифа в вашем
        инвентаре. Например, если Глиф имеет все те же эффекты, как у другого Глифа, но значения
        ВСЕХ эффектов хуже, то он будет удалён.`;
      return `Чистка удаляет Глифы, которые однозначно хуже любого другого Глифа, при этом сохраняя достаточно для
        экипировки полного комплекта со всеми эффектами. Это то же, что Жёсткая Чистка, за исключением того, что обычная
        Чистка не удалит никакой Глиф до тех пор, пока не найдёт пять Глифов, которые лучше (вместо только одного).`;
    },
    topLabel() {
      return `Вы собираетесь ${this.harsh ? `Жёстко Чистить` : `Чистить`} ваши Глифы`;
    },

    // These two don't need to be reactive since the modal force-closes itself whenever glyphs change
    glyphsTotal() {
      return Glyphs.inventory.filter(slot => slot !== null).length;
    },
    glyphsDeleted() {
      return Glyphs.autoClean(this.threshold, false);
    },
  },
  methods: {
    handleYesClick() {
      Glyphs.autoClean(this.threshold, true);
    },
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="autoClean"
    @confirm="handleYesClick"
  >
    <template #header>
      {{ topLabel }}
    </template>
    <div class="c-modal-message__text">
      Это может удалить Глифы в вашем инвентаре, которые достаточно хороши для того, чтобы вы использовали их
      позднее. Чистка будет Чистить Глифы, основываясь на вашем режиме Чистки. Вы уверены, что хотите это сделать?
      <br>
      <br>
      {{ explanation }}
    </div>
    <br>
    <div class="c-modal-hard-reset-danger">
      {{ extraMessage }}
    </div>
  </ModalWrapperChoice>
</template>
